import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 1.5rem;
`;

export const Header = styled.p`
  display: none;
  margin-bottom: 1.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #252525;
  @media ${MEDIA_QUERIES.tablet} {
    display: block;
  }
`;
